import type { ReactNode } from 'react';
import KokoFloat from './KokoFloat';
import AppFooter from '../../components/shared/AppFooter';

interface ThemeRootProps {
  children: ReactNode;
  className?: string;
}

export default function ThemeRoot({ children, className = '' }: ThemeRootProps) {
  return (
    <div className={`min-h-screen bg-base text-ink ${className}`}>
      {children}
      <AppFooter />
      <KokoFloat />
    </div>
  );
}
